import { render, staticRenderFns } from "./vent.vue?vue&type=template&id=ef8dfb9c"
import script from "./vent.vue?vue&type=script&lang=js"
export * from "./vent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports